module.exports = __webpack_public_path__ + "images/tips/getting-started@2x.0d3b3621a0f781cdca0e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tips/getting-started@2x.png
// module id = 1ayY
// module chunks = 12